module.exports = __webpack_public_path__ + "img/eduID.b96858fa.svg";